module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/37de3069a22757d8aa830b8632980f94.png";